export default __webpack_public_path__ + "static/media/exclusive-maxi.cde99ff9.glb";